//formatter函数将数据进行百分比转换
export default {
  methods: {
    formatterValToPercentage(opt) {
      opt.series.forEach(serie => {
        serie.label.formatter = params => {
          let formatterVal = (params.value * 100).toFixed(2)
          let name = opt.isShowDataName ? "{b|\n" + params.name + "}" : ""
          return formatterVal + "{valueUnit|%}" + name
        }
      })
    },
    formatterValToNumber(opt) {
      opt.series.forEach((serie, index) => {
        let max = serie.data[0].max || 100
        let formatterVal = Number(serie.data[0].value * 10 * max) / 10
        //获取小数点后面位数
        let len1 = this.getDecimalLength(formatterVal)
        if(serie.data[0].realValue){
          formatterVal = serie.data[0].realValue
        } else if(len1 >= 10){
          formatterVal = Math.round(formatterVal)
        }
        let name = opt.isShowDataName ? "{b|\n" + serie.data[0].name + "}" : ""
        if(!this.options.chartOption.getValueIsPercentage && this.options.numberCount){
          this.checkFormatterValue()
        }else{
          serie.label.formatter = formatterVal + "{valueUnit|}" + name
        }
      })
    },
    getDecimalLength(num) {
      // 将数字转换为字符串
      const numStr = num.toString();
      // 分割小数点前后的字符串
      const parts = numStr.split('.');
      // 如果小数点后面有数字，则长度为分割后数组的第二个元素的长度，否则为0
      return parts.length > 1 ? parts[1].length : 0;
    }
  }
}
